/* Elite EG: visitor journey tracker for the CRM page «زوار الموقع والفورم».
   Follows /mnt/project-files/storefront-journey/spec.md: one small anonymous event per step,
   sent to the CRM's /api/storefront/track. Visitor id = localStorage el_vid (shared with Mevy).
   A phone number is sent only when the visitor types a valid mobile into our order form.
   Loaded with defer from snippets/meta-tags.liquid (rendered in <head> on every page).
   elite-buy.js can also report straight through window.elJourney('form_fail', {why: 'sold_out'}). */
(function () {
  if (window.__elJourney) return;
  window.__elJourney = 1;
  try {
    if (navigator.webdriver) return;
    if (window.Shopify && window.Shopify.designMode) return;
  } catch (e) {}

  var API = 'https://elite-crm-kohl.vercel.app/api/storefront/track';
  var IDLE = 30 * 60 * 1000;
  var ID = /^[A-Za-z0-9_.-]{4,40}$/;

  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function rid() { var c = 'abcdefghijklmnopqrstuvwxyz0123456789', s = ''; for (var i = 0; i < 16; i++) s += c.charAt(Math.floor(Math.random() * 36)); return s; }

  var vid = ls('el_vid');
  if (!vid || !ID.test(vid)) { vid = rid(); ls('el_vid', vid); }
  var sid = ss('el_sid'), last = Number(ls('el_sid_t') || 0), first = false;
  if (!sid || !ID.test(sid) || Date.now() - last > IDLE) { sid = rid(); ss('el_sid', sid); first = true; }
  function touch() { ls('el_sid_t', String(Date.now())); }

  var lang = (document.documentElement.lang || '').slice(0, 2) === 'en' ? 'en' : 'ar';
  function cookie(k) { var m = document.cookie.match('(?:^|; )' + k + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : ''; }
  function handle() { var m = /\/products\/([^/?#]+)/.exec(location.pathname); return m ? decodeURIComponent(m[1]).toLowerCase() : ''; }
  function pageType() {
    var p = location.pathname.replace(/^\/(ar|en)(?=\/|$)/, '') || '/', meta = '';
    try { meta = window.ShopifyAnalytics.meta.page.pageType || ''; } catch (e) {}
    if (/^\/products\//.test(p) || meta === 'product') return 'product';
    if (/^\/collections\//.test(p) || meta === 'collection') return 'collection';
    if (/^\/cart\/?$/.test(p)) return 'cart';
    if (/^\/search/.test(p) || meta === 'searchresults') return 'search';
    if (/^\/pages\//.test(p) || meta === 'page') return 'page';
    if (p === '/' || meta === 'home') return 'home';
    return 'other';
  }

  function send(e, extra) {
    try {
      var b = { e: e, v: vid, s: sid, t: (cookie('cart') || '').split('?')[0], ts: Date.now(), l: lang, u: location.pathname.slice(0, 200) };
      var h = handle();
      if (h) b.p = h;
      if (extra) for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k) && extra[k] !== '' && extra[k] != null) b[k] = extra[k];
      touch();
      var json = JSON.stringify(b);
      if (navigator.sendBeacon && navigator.sendBeacon(API, json)) return;
      fetch(API, { method: 'POST', mode: 'no-cors', keepalive: true, body: json });
    } catch (x) {}
  }
  window.elJourney = send;

  /* page: where she came from only on the first page of a visit */
  var pg = { pt: pageType(), ti: (document.title || '').slice(0, 120) };
  if (first) {
    var q = new URLSearchParams(location.search);
    pg.src = q.get('utm_source') || (q.get('fbclid') ? 'facebook' : q.get('ttclid') ? 'tiktok' : q.get('gclid') ? 'google' : '');
    pg.cmp = (q.get('utm_campaign') || '').slice(0, 80);
    try { var r = document.referrer ? new URL(document.referrer).hostname : ''; if (r && r !== location.hostname) pg.ref = r; } catch (e) {}
    pg.first = 1;
  }
  send('page', pg);

  /* variant: colour / size picked on a product page */
  function currentVariant() {
    var v = new URLSearchParams(location.search).get('variant');
    if (v) return v;
    var fs = document.querySelectorAll('form[action*="/cart/add"]');
    for (var k = 0; k < fs.length; k++) {
      if (fs[k].closest('[data-el-form]')) continue;
      var i = fs[k].querySelector('[name="id"]');
      if (i && i.value) return i.value;
    }
    return '';
  }
  var lastVariant = currentVariant();
  if (pageType() === 'product') {
    document.addEventListener('change', function (ev) {
      var t = ev.target;
      if (!t || !t.closest || t.closest('[data-el-form]')) return;
      /* the theme updates the URL / hidden id after it re-renders, so look a few times */
      [150, 600, 1500].forEach(function (ms) {
        setTimeout(function () {
          var v = currentVariant();
          if (v && v !== lastVariant) { lastVariant = v; send('variant', { vr: v }); }
        }, ms);
      });
    }, true);
  }

  /* cart_add: the theme posts /cart/add with fetch; a plain form submit is caught too */
  function addInfo(body) {
    try {
      if (!body) return {};
      if (typeof FormData !== 'undefined' && body instanceof FormData) return { vr: String(body.get('id') || ''), q: Number(body.get('quantity') || 1) };
      if (typeof body === 'string') {
        if (body.charAt(0) === '{') { var j = JSON.parse(body), it = (j.items && j.items[0]) || j; return { vr: String(it.id || ''), q: Number(it.quantity || 1) }; }
        var u = new URLSearchParams(body); return { vr: u.get('id') || '', q: Number(u.get('quantity') || 1) };
      }
    } catch (e) {}
    return {};
  }
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/add/.test(url) && !(init && init.__elForm)) {
        var info = addInfo(init && init.body);
        p.then(function (r) { if (r && r.ok) send('cart_add', info); }).catch(function () {});
      }
      return p;
    };
  }
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!f || !f.getAttribute || f.closest('[data-el-form]')) return;
    if (/\/cart\/add/.test(f.getAttribute('action') || '') && !(window.customElements && window.customElements.get('product-form'))) {
      var i = f.querySelector('[name="id"]'), q = f.querySelector('[name="quantity"]');
      send('cart_add', { vr: i ? i.value : '', q: q ? Number(q.value) || 1 : 1 });
    }
  }, true);

  /* checkout and WhatsApp taps */
  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('a, button') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    /* checked after the click is handled: «اطلبي دلوقتي» links to the cart permalink but only opens our form */
    setTimeout(function () {
      if (ev.defaultPrevented) return;
      if (a.getAttribute('name') === 'checkout' || /\/checkouts?(\/|$|\?)/.test(href) || /\/cart\/\d+:\d+/.test(href)) send('checkout');
      else if (/wa\.me|api\.whatsapp|whatsapp:/i.test(href)) send('wa');
    }, 0);
  }, true);

  /* our order form: opened (elite-buy.js puts el-form-open on <html>) */
  var formOpen = false;
  new MutationObserver(function () {
    var on = document.documentElement.classList.contains('el-form-open');
    if (on && !formOpen) { send('form_open'); leadSoon(); }
    formOpen = on;
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

  /* form_lead: a valid mobile typed in the form; again when name, number or order change (2 s quiet) */
  /* Arabic / Persian digits to 0-9 (ASCII-only source, whatever charset the asset is served with) */
  function digit(d) { var c = d.charCodeAt(0); return String(c - (c >= 0x06f0 ? 0x06f0 : 0x0660)); }
  function mobile(raw) {
    var s = String(raw || '').replace(/[\u0660-\u0669\u06f0-\u06f9]/g, digit).replace(/[^\d+]/g, '');
    if (s.indexOf('+20') === 0) s = '0' + s.slice(3);
    else if (s.indexOf('0020') === 0) s = '0' + s.slice(4);
    else if (s.indexOf('20') === 0 && s.length === 12) s = '0' + s.slice(2);
    else if (/^1[0125]\d{8}$/.test(s)) s = '0' + s;
    return /^01[0125]\d{8}$/.test(s) ? s : '';
  }
  function field(sheet, k) { var f = sheet.querySelector('[data-el-form-field="' + k + '"]'); return f ? String(f.value || '').trim() : ''; }
  function items(sheet) {
    var out = [], sels = sheet.querySelectorAll('[data-el-form-lines] [data-el-form-line-variant]');
    for (var i = 0; i < sels.length && out.length < 5; i++) {
      var row = sels[i].closest('[data-el-form-line]') || sels[i].parentNode;
      var qi = row && row.querySelector ? row.querySelector('[data-el-form-qty]') : null;
      if (/^\d{5,20}$/.test(sels[i].value)) out.push({ vr: sels[i].value, q: qi ? parseInt(qi.value, 10) || 1 : 1, p: (row && row.getAttribute && row.getAttribute('data-handle')) || handle() || undefined });
    }
    return out;
  }
  function total(sheet) {
    var el = sheet.querySelector('[data-el-form-total], [data-el-form-sum-total]');
    var n = el ? Number(String(el.textContent || '').replace(/[\u0660-\u0669\u06f0-\u06f9]/g, digit).replace(/[^\d.]/g, '')) : 0;
    return n > 0 ? Math.round(n) : undefined;
  }
  var leadTimer = null, lastLead = '';
  function leadNow() {
    var sheet = document.querySelector('[data-el-form]');
    if (!sheet) return;
    var ph = mobile(field(sheet, 'phone'));
    if (!ph) return;
    var d = { ph: ph, n: field(sheet, 'name').slice(0, 60), g: field(sheet, 'governorate'), items: items(sheet), tot: total(sheet) };
    var key = JSON.stringify(d);
    if (key === lastLead) return;
    lastLead = key;
    send('form_lead', d);
  }
  function leadSoon() { clearTimeout(leadTimer); leadTimer = setTimeout(leadNow, 2000); }
  ['input', 'change'].forEach(function (type) {
    document.addEventListener(type, function (ev) { var t = ev.target; if (t && t.closest && t.closest('[data-el-form]')) leadSoon(); }, true);
  });

  /* form_submit: elite-buy.js writes the order number into [data-el-form-done-no] */
  function watchDone() {
    var no = document.querySelector('[data-el-form-done-no]');
    if (!no) return;
    var sent = '';
    new MutationObserver(function () {
      var o = (no.textContent || '').trim();
      if (/^#?\d{3,8}$/.test(o) && o !== sent) { sent = o; clearTimeout(leadTimer); send('form_submit', { o: o.charAt(0) === '#' ? o : '#' + o }); }
    }).observe(no, { childList: true, characterData: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDone); else watchDone();
})();
